var $a68efd3a1203bd8a$exports = {};
$a68efd3a1203bd8a$exports = {
    "loading": `Caricamento...`,
    "placeholder": `Seleziona\u{2026}`
};


export {$a68efd3a1203bd8a$exports as default};
//# sourceMappingURL=it-IT.mjs.map
